<template>
  <div>
    <loading-container v-if="loading"></loading-container>

    <div v-else class="container">
      <div class="row" style="margin-bottom: 22px;">
        <div v-if="hasPermission('admin')" class="col-xs-4 col-sm-offset-12">
          <select-widget
              v-model="targetMetric"
              :options="[{value: 'time_channel_target', label: 'Target'}, {value: 'time_channel_management_target', label: 'Management Target'}]"
          ></select-widget>
        </div>

        <div class="col-xs-4" :class="hasPermission('admin') ? '' : 'col-sm-offset-16'">
          <TypeaheadWidget
              v-model="user"
              name="user_id"
              endpoint="/api/v2/users"
              :token="shared.token"
              path="data.data"
              placeholder="(all users)"
              :result-label-property="row => row.attributes.full_name"
          />
        </div>

        <div class="col-xs-4">
          <div class="dashboard-date-widget">
            <date-widget :value="year" format="YYYY" original-format="YYYY" @input="navigate"></date-widget>

            <i class="dashboard-date-widget__icon fa fa-sort"></i>
          </div>
        </div>
      </div>

      <hr class="panel-separator">

      <div class="row">
        <div class="col-sm-8">
          <index-number
              :year="year"
              :time-based-channel="timeBasedChannel"
              :target-metric="targetMetric"
              :user="user"
          ></index-number>
        </div>

        <div class="col-sm-8">
          <revenue-number
              :year="year"
              :time-based-channel="timeBasedChannel"
              :target-metric="targetMetric"
              :user="user"
          ></revenue-number>
        </div>

        <div class="col-sm-8">
          <difference-number
              :year="year"
              :time-based-channel="timeBasedChannel"
              :target-metric="targetMetric"
              :user="user"
          ></difference-number>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-24">
          <subchannel-overview
              :portal="portal"
              :time-based-channel="timeBasedChannel"
              :year="year"
              :filters="filters"
              :target-metric="targetMetric"
              :user="user"
          ></subchannel-overview>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-24">
          <monthly-overview
              :year="year"
              :time-based-channel="timeBasedChannel"
              :filters="filters"
              :target-metric="targetMetric"
              :user="user"
              :portal="portal"
          ></monthly-overview>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.dashboard-date-widget {
  position: relative;
}

.dashboard-date-widget__icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}
</style>

<script>
import http from '@/http'
import store from '@/store'
import DateWidget from '@/vendor/forms/FormGroups/Widgets/Date'
import DifferenceNumber from '@/pages/Administration/Portals/Edit/Tabs/TimeBasedChannelDashboard/Panels/DifferenceNumber'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import IndexNumber from '@/pages/Administration/Portals/Edit/Tabs/TimeBasedChannelDashboard/Panels/IndexNumber'
import LoadingContainer from '@/components/Layout/LoadingContainer'
import MonthlyOverview from '@/pages/Administration/Portals/Edit/Tabs/TimeBasedChannelDashboard/Panels/MonthlyOverview'
import SubchannelOverview from '@/pages/Administration/Portals/Edit/Tabs/TimeBasedChannelDashboard/Panels/SubchannelOverview'
import Permissions from '@/mixins/Permissions'
import RevenueNumber from '@/pages/Administration/Portals/Edit/Tabs/TimeBasedChannelDashboard/Panels/RevenueNumber'
import SelectWidget from '@/vendor/forms/FormGroups/Widgets/Select'
import TypeaheadWidget from "../../../../../../vendor/forms/FormGroups/Widgets/Typeahead.vue";

export default {
  components: {
    TypeaheadWidget,
    DateWidget,
    DifferenceNumber,
    HeadlineContainer,
    IndexNumber,
    LoadingContainer,
    MonthlyOverview,
    RevenueNumber,
    SelectWidget,
    SubchannelOverview
  },

  mixins: [Permissions],

  model: {
    prop: 'portal',
    event: 'portal-updated'
  },

  props: ['portal','year', 'timeBasedChannelId'],

  data() {
    return {
      targetMetric: 'time_channel_target',
      user: null,
      timeBasedChannel: null,
      loading: true,

      shared: store
    }
  },

  mounted() {
    http.get('/api/v2/time-based-channels/' + this.timeBasedChannelId).then(response => {
      this.timeBasedChannel = response.data.data

      this.loading = false
    })
  },

  computed: {
    filters() {
      return [
        {dimension: 'time_based_channel_id', value: this.timeBasedChannelId},
      ]
    }
  },

  methods: {
    navigate(year) {
      this.$router.push(year)
    }
  }
}
</script>
